/* ============================================================================
   ATHLO+ — Community Club Finder
   ----------------------------------------------------------------------------
   Filterable directory of Singapore sports clubs. Search + sport / region /
   level filters → club cards with schedule, location and follow links.
   Data: window.HUB_CLUBS (assets/hub-clubs.js). Mounts into [data-clubfinder].
   ========================================================================== */
(function () {
  'use strict';

  // Admin-editable metaobjects (window.HUB_CLUBS_MO, injected by the section when
  // hub_club metaobjects exist) are authoritative — but MERGE in any seed-only
  // clubs by id so newly-added sports not yet migrated to metaobjects still show
  // (mirrors hub-shoe-lab.js). Falls back to the full JS seed when no MO present.
  var MO = (window.HUB_CLUBS_MO && window.HUB_CLUBS_MO.length) ? window.HUB_CLUBS_MO : null;
  var SEED = window.HUB_CLUBS || [];
  var CLUBS;
  if (MO) {
    var seen = {};
    MO.forEach(function (c) { if (c && c.id) seen[c.id] = 1; });
    CLUBS = MO.concat(SEED.filter(function (c) { return c && c.id && !seen[c.id]; }));
  } else {
    CLUBS = SEED.slice();
  }
  if (!CLUBS.length) return;

  var SPORT_ORDER = ['Running', 'Trail', 'Hyrox', 'Strength', 'Triathlon', 'Cycling', 'Swimming', 'Pickleball', 'Padel', 'Tennis', 'Badminton', 'Table Tennis', 'Football', 'Basketball', 'Volleyball', 'Floorball', 'Rugby', 'Netball', 'Hockey', 'Dragon Boat', 'Ultimate', 'Climbing', 'Yoga', 'Hiking'];
  var SPORTS = SPORT_ORDER.filter(function (s) { return CLUBS.some(function (c) { return c.sport === s; }); });
  var REGION_ORDER = ['Central', 'East', 'West', 'North', 'Northeast', 'Islandwide'];
  var REGIONS = REGION_ORDER.filter(function (r) { return CLUBS.some(function (c) { return c.region === r; }); });
  var LEVELS = ['Beginner', 'All levels', 'Intermediate', 'Advanced', 'Members'].filter(function (l) { return CLUBS.some(function (c) { return c.level === l; }); });

  // Map a free-text sport (e.g. from ?sport= on a "Choose your tribe" card) to a
  // real chip value. Handles exact, then loose contains either direction so
  // "Padel / Pickleball" or "Cycling / Tri" still resolve. Returns '' if none.
  function matchSport(raw) {
    if (!raw) return '';
    var q = String(raw).trim().toLowerCase();
    if (!q) return '';
    var i;
    for (i = 0; i < SPORTS.length; i++) { if (SPORTS[i].toLowerCase() === q) return SPORTS[i]; }
    for (i = 0; i < SPORTS.length; i++) {
      var s = SPORTS[i].toLowerCase();
      if (q.indexOf(s) > -1 || s.indexOf(q) > -1) return SPORTS[i];
    }
    return '';
  }
  // Pre-selected sport from the URL (?sport= preferred, #sport= fallback).
  var INITIAL_SPORT = '';
  try {
    var qp = new URLSearchParams(window.location.search).get('sport');
    if (!qp && /[#&]sport=/.test(window.location.hash)) {
      qp = decodeURIComponent((window.location.hash.split('sport=')[1] || '').split('&')[0]);
    }
    INITIAL_SPORT = matchSport(qp);
  } catch (e) {}

  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(name, detail) {
    try { window.dispatchEvent(new CustomEvent('hub:clubfinder', { detail: Object.assign({ event: name }, detail || {}) })); } catch (e) {}
    if (typeof window.gtag === 'function') window.gtag('event', name, detail || {});
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  /* === ADDON 2026-10-27 (owner-approved "G4"): MEETS SOONEST ===
     CAMP8's last three app releases went into crew session schedules; we already hold them, as the free-text `sched`
     field ("Tue 7pm", "Wed 7pm · Sat/Sun 7am", "Weekend mornings"). This reads the WEEKDAYS out of that text and can
     order the list by the next one, counted from today in Singapore. No-invent rule: a day is only used when the club's
     own schedule names it. Text that says the day is not every week (bi-weekly, monthly, 1st & 3rd, last Sat) gets no
     "Meets" tag and sorts after the weekly clubs; text with no day at all ("Class schedule", "Coached sessions") keeps
     its place at the end. The schedule line on the card is unchanged, so the reader always sees the club's own words.
     Phones open in this order; desktop keeps A–Z unless the visitor switches. Gate: _verify/club-meets-test.mjs. */
  var DAY_RX = [
    [1, /\bmon(day)?s?\b/i], [2, /\btue(s|sday)?s?\b/i], [3, /\bwed(nesday)?s?\b/i], [4, /\bthu(rs?|rsday)?s?\b/i],
    [5, /\bfri(day)?s?\b/i], [6, /\bsat(urday)?s?\b/i], [0, /\bsun(day)?s?\b/i]
  ];
  var IRREGULAR_RX = /bi-?weekly|fortnight|monthly|\bmonth\b|\b(1st|2nd|3rd|4th|first|last)\b/i;
  function meetDays(sched) {
    var t = String(sched || ''), days = {}, any = false, i;
    if (/\b(daily|every day|most days)\b/i.test(t)) { for (i = 0; i < 7; i++) days[i] = 1; any = true; }
    // "most days" promises no particular day, so it sorts with the not-every-week clubs and gets no tag
    if (/\bmost days\b/i.test(t)) return { days: days, weekly: false };
    if (/\bweekends?\b/i.test(t)) { days[6] = 1; days[0] = 1; any = true; }
    if (/\bweekdays\b/i.test(t)) { for (i = 1; i < 6; i++) days[i] = 1; any = true; }
    for (i = 0; i < DAY_RX.length; i++) if (DAY_RX[i][1].test(t)) { days[DAY_RX[i][0]] = 1; any = true; }
    if (!any) return null;
    return { days: days, weekly: !IRREGULAR_RX.test(t) };
  }
  // Singapore weekday (0 = Sun) without trusting the device's time zone: SGT is UTC+8 with no DST.
  function sgDow(now) { return new Date(now + 8 * 3600000).getUTCDay(); }
  var DOW_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  /** Days until this club next meets (0 = today), or null when its schedule names no weekly day. */
  function daysToNext(c, today) {
    var m = c.__meet === undefined ? (c.__meet = meetDays(c.sched)) : c.__meet;
    if (!m || !m.weekly) return null;
    for (var k = 0; k < 7; k++) if (m.days[(today + k) % 7]) return k;
    return null;
  }
  function meetLabel(k, today) {
    return k === 0 ? 'Meets today' : k === 1 ? 'Meets tomorrow' : 'Meets ' + DOW_NAMES[(today + k) % 7];
  }
  function bySoonest(list, today) {
    return list.map(function (c, i) {
      var k = daysToNext(c, today), m = c.__meet;
      // tier 0 = weekly with a named day, 1 = named day but not every week, 2 = no day named
      return { c: c, i: i, k: k, tier: k !== null ? 0 : (m ? 1 : 2) };
    }).sort(function (a, b) {
      return (a.tier - b.tier) || ((a.k === null ? 9 : a.k) - (b.k === null ? 9 : b.k)) || (a.i - b.i);
    }).map(function (x) { return x.c; });
  }
  var PHONE = !!(window.matchMedia && window.matchMedia('(max-width: 760px)').matches);
  /* === /ADDON === */

  function Finder(root) {
    var state = { q: '', sport: INITIAL_SPORT || '', region: '', level: '', savedOnly: false, order: PHONE ? 'soon' : 'az' };

    function filtered() {
      var q = state.q.trim().toLowerCase();
      return CLUBS.filter(function (c) {
        // soft-delete: a club whose owner deleted their account stays in the data
        // but is flagged inactive so the community listing isn't destroyed for others.
        if (c.active === false || c.deleted) return false;
        if (state.savedOnly && !(window.HubSave && window.HubSave.has('club:' + c.id))) return false;
        if (state.sport && c.sport !== state.sport) return false;
        if (state.region && c.region !== state.region) return false;
        if (state.level && c.level !== state.level) return false;
        if (q) {
          var hay = (c.name + ' ' + c.sport + ' ' + c.area + ' ' + c.region + ' ' + (c.blurb || '')).toLowerCase();
          if (hay.indexOf(q) < 0) return false;
        }
        return true;
      });
    }

    function card(c, meet) {
      var links = '';
      if (c.web) links += '<a class="club__link" href="' + esc(c.web) + '" target="_blank" rel="noopener" data-cf="web"><span class="club__link-i" aria-hidden="true">↗</span>Visit</a>';
      if (c.ig) links += '<a class="club__link" href="https://instagram.com/' + esc(c.ig) + '" target="_blank" rel="noopener" data-cf="ig"><span class="club__link-i" aria-hidden="true">◎</span>@' + esc(c.ig) + '</a>';
      if (c.maps || c.area) links += '<a class="club__link" href="https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(c.maps || ((c.area || '') + ' Singapore')) + '" target="_blank" rel="noopener" data-cf="map"><span class="club__link-i" aria-hidden="true">⌖</span>Map</a>';
      var node = el('article', 'club');
      node.innerHTML =
        '<div class="club__top">' +
          '<span class="club__sport">' + esc(c.sport) + '</span>' +
          (meet ? '<span class="club__meets">' + esc(meet) + '</span>' : '') +
          '<span class="club__level">' + esc(c.level) + '</span>' +
        '</div>' +
        '<h3 class="club__name">' + esc(c.name) + '</h3>' +
        (c.blurb ? '<p class="club__blurb">' + esc(c.blurb) + '</p>' : '') +
        '<dl class="club__meta">' +
          '<div><dt aria-label="Location">⌖</dt><dd>' + esc(c.area) + ' <span class="club__region">· ' + esc(c.region) + '</span></dd></div>' +
          '<div><dt aria-label="Schedule">◔</dt><dd>' + (c.sched ? esc(c.sched) : 'Check their channel for session times') + '</dd></div>' +
          (c.fee ? '<div><dt aria-label="Cost">$</dt><dd>' + esc(c.fee) + '</dd></div>' : '') +
        '</dl>' +
        (links ? '<div class="club__links">' + links + '</div>' : '');
      node.querySelectorAll('[data-cf]').forEach(function (a) {
        a.addEventListener('click', function () { track('club_contact', { club: c.id, channel: a.getAttribute('data-cf'), sport: c.sport }); });
      });
      if (window.HubSave) node.appendChild(window.HubSave.button({
        id: 'club:' + c.id, type: 'Club', name: c.name,
        sub: [c.sport, c.area].filter(Boolean).join(' · '),
        url: c.web || ('/pages/club-listings?sport=' + encodeURIComponent(c.sport || ''))
      }));
      return node;
    }

    function render() {
      state.limit = null; // reset Load-More paging on any control rebuild
      root.innerHTML = '';

      /* controls */
      var controls = el('div', 'cf__controls');

      var search = el('div', 'cf__search');
      var input = el('input', 'cf__input');
      input.type = 'search'; input.placeholder = 'Search clubs, sports or areas — e.g. Punggol, triathlon, beginner…';
      input.value = state.q; input.setAttribute('aria-label', 'Search clubs');
      input.addEventListener('input', function () { state.q = input.value; paint(); });
      search.appendChild(input);
      controls.appendChild(search);

      /* sport chips */
      var chips = el('div', 'cf__chips');
      var allChip = el('button', 'cf__chip' + (state.sport ? '' : ' is-on'), 'All sports');
      allChip.type = 'button';
      allChip.addEventListener('click', function () { state.sport = ''; render(); });
      chips.appendChild(allChip);
      if (window.HubMember && window.HubMember.is() && window.HubSave) {
        var savedChip = el('button', 'cf__chip' + (state.savedOnly ? ' is-on' : ''), '♥ Saved');
        savedChip.type = 'button';
        savedChip.addEventListener('click', function () { state.savedOnly = !state.savedOnly; render(); });
        chips.appendChild(savedChip);
      }
      SPORTS.forEach(function (s) {
        var n = CLUBS.filter(function (c) { return c.sport === s; }).length;
        var chip = el('button', 'cf__chip' + (state.sport === s ? ' is-on' : ''), esc(s) + ' <span class="cf__chip-n">' + n + '</span>');
        chip.type = 'button';
        chip.addEventListener('click', function () { state.sport = (state.sport === s ? '' : s); render(); track('club_filter', { sport: s }); });
        chips.appendChild(chip);
      });
      controls.appendChild(chips);
      if (state.sport) {
        var onChip = chips.querySelector('.cf__chip.is-on');
        if (onChip) requestAnimationFrame(function () { chips.scrollLeft = Math.max(0, onChip.offsetLeft - chips.offsetLeft - 16); });
      }

      /* region + level selects + reset */
      var selects = el('div', 'cf__selects');
      var reg = el('select', 'cf__select');
      reg.setAttribute('aria-label', 'Filter by area');
      reg.innerHTML = '<option value="">All areas</option>' + REGIONS.map(function (r) { return '<option value="' + r + '"' + (state.region === r ? ' selected' : '') + '>' + r + '</option>'; }).join('');
      reg.addEventListener('change', function () { state.region = reg.value; render(); });
      var lvl = el('select', 'cf__select');
      lvl.setAttribute('aria-label', 'Filter by level');
      lvl.innerHTML = '<option value="">Any level</option>' + LEVELS.map(function (l) { return '<option value="' + l + '"' + (state.level === l ? ' selected' : '') + '>' + l + '</option>'; }).join('');
      lvl.addEventListener('change', function () { state.level = lvl.value; render(); });
      selects.appendChild(reg); selects.appendChild(lvl);
      if (state.q || state.sport || state.region || state.level) {
        var reset = el('button', 'cf__reset', 'Clear filters'); reset.type = 'button';
        reset.addEventListener('click', function () { state = { q: '', sport: '', region: '', level: '', order: state.order }; render(); });
        selects.appendChild(reset);
      }
      controls.appendChild(selects);
      root.appendChild(controls);

      /* results region (re-painted on search without rebuilding controls) */
      var results = el('div', 'cf__results'); results.setAttribute('data-cf-results', '');
      root.appendChild(results);
      paintInto(results);
      // keep focus + caret in the search box after a full render
      if (document.activeElement !== input && state.q) { /* no-op */ }
    }

    function paintInto(results) {
      var list = filtered();
      var today = sgDow(Date.now());
      if (state.order === 'soon') list = bySoonest(list, today);
      results.innerHTML = '';
      var count = el('p', 'cf__count', '<strong>' + list.length + '</strong> ' + (list.length === 1 ? 'club' : 'clubs') + (state.sport ? ' · ' + esc(state.sport) : '') + (state.region ? ' · ' + esc(state.region) : ''));
      var bar = el('div', 'cf__bar');
      bar.appendChild(count);
      var order = el('div', 'cf__order');
      order.setAttribute('role', 'group'); order.setAttribute('aria-label', 'Order clubs');
      [['soon', 'Meets soonest'], ['az', 'A–Z']].forEach(function (o) {
        var b = el('button', 'cf__order-b' + (state.order === o[0] ? ' is-on' : ''), o[1]);
        b.type = 'button'; b.setAttribute('aria-pressed', String(state.order === o[0]));
        b.addEventListener('click', function () {
          if (state.order === o[0]) return;
          state.order = o[0]; state.limit = null; paintInto(results); track('club_order', { order: o[0] });
        });
        order.appendChild(b);
      });
      bar.appendChild(order);
      results.appendChild(bar);
      if (!list.length) {
        results.appendChild(el('div', 'cf__empty', "No clubs match yet. Try clearing a filter — or tell us who's missing and we'll add them."));
        return;
      }
      // Uncapped-dropdown guard: never inject 1,000 cards at once (browser freeze).
      // Render in hard-capped batches with a "Load more" button. (Storefront-native
      // {% paginate %} is used for server-rendered lists; this is the client mirror.)
      var PAGE = 24;
      if (state.limit == null) state.limit = PAGE;
      var shown = list.slice(0, state.limit);
      var grid = el('div', 'cf__grid');
      shown.forEach(function (c) {
        var k = state.order === 'soon' ? daysToNext(c, today) : null;
        grid.appendChild(card(c, k === null ? '' : meetLabel(k, today)));
      });
      results.appendChild(grid);
      if (list.length > shown.length) {
        var more = el('button', 'cf__more', 'Load more (' + (list.length - shown.length) + ' more)');
        more.type = 'button';
        more.addEventListener('click', function () { state.limit += PAGE; paintInto(results); });
        results.appendChild(more);
      }
    }

    // light-weight repaint (used while typing) so the input keeps focus
    function paint() {
      state.limit = null; // new filter/search → restart Load-More paging
      var results = root.querySelector('[data-cf-results]');
      if (results) paintInto(results); else render();
    }

    render();
  }

  function init() {
    var mounted = null;
    document.querySelectorAll('[data-clubfinder]').forEach(function (root) {
      if (root.__clubfinder) return; root.__clubfinder = true; new Finder(root); mounted = root;
    });
    // Arrived from a "Choose your tribe" card → bring the pre-filtered finder into view.
    if (mounted && (INITIAL_SPORT || window.location.hash === '#clubs')) {
      requestAnimationFrame(function () {
        var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 76;
        var top = mounted.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
        if (window.__lenis && typeof window.__lenis.scrollTo === 'function') window.__lenis.scrollTo(top, { duration: 0.8 });
        else window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
